<template>
    <div class="container">
        <form class="form-signin" v-on:submit.prevent="resetFormSubmit">
            <h2 class="form-signin-heading">{{langResetPage.resetPassword[locale]}}</h2>
            <form-input :labelText="langResetPage.email[locale]" :placeholder="langResetPage.emailPlaceholder[locale]" v-model="resetForm.email" :inputType="'email'" :required="true" :tooltipTitle="langResetPage.emailToolTip[locale]" :disabled="true" :extraValidation="EMAIL_REGEX.test($route.query.email)"/>
            <form-input :labelText="langResetPage.newPassword[locale]" :placeholder="langResetPage.newPasswordPlaceholder[locale]" v-model="resetForm.newPassword" :inputType="'password'" :required="true" :tooltipTitle="langResetPage.newPasswordToolTip[locale]"/>
            <form-input :labelText="langResetPage.confirmNewPassword[locale]" :placeholder="langResetPage.confirmNewPasswordPlaceholder[locale]" v-model="resetForm.confirmNewPassword" :inputType="'password'" :required="true" :tooltipTitle="langResetPage.confirmNewPasswordToolTip[locale]" :extraValidation="resetForm.password === resetForm.confirmPassword"/>
            <b-alert variant="danger" :show="!!reset.errMessage">{{reset.errMessage}}</b-alert>
            <b-alert v-if="!EMAIL_REGEX.test($route.query.email)" variant="danger" show>{{langResetPage.invalidEmailDetected[locale]}}</b-alert>
            <nettipyora-button :text="langResetPage.submitBtn[locale]" :loading="reset.loading" :className="'btn-primary'" :submit="true" :disabled="!EMAIL_REGEX.test($route.query.email)"/>
            <br /><br />
        </form>
    </div>
</template>

<script>
import NettipyoraButton from '@/components/NettipyoraButton';
import FormInput from '@/components/FormInput';
import { mapState } from 'vuex';
import { EMAIL_REGEX } from '@/store/constant';
import langResetPage from '@/store/lang/reset';

export default {
    name: "Forgot",
    components: {
        NettipyoraButton, FormInput
    },
    computed: mapState({
        reset: state => state.Reset.reset,
        locale: state => state.locale
    }),
    data() {
        return {
            EMAIL_REGEX, langResetPage,
            resetForm: {
                email: this.$route.query.email,
                newPassword: "",
                confirmNewPassword: ""
            }
        }
    },
    methods: {
        resetFormSubmit() {
            this.$store.dispatch('RESET_SUBMIT', {email: this.resetForm.email, resetID: this.$route.query.resetID, payload: {newPassword: this.resetForm.newPassword, confirmNewPassword: this.resetForm.confirmNewPassword}});
        }
    }
}
</script>

